
// document.addEventListener('click', function(e){
//   console.log(e.target);
//   if (e.target.classList.contains('bndlr-add-to-cart') ) {
//     console.log('Bundler button clicked!...');
//     setTimeout(function(){
//       theme.classes.CoreCart.updateTotals(function(){});
//       theme.partials.Cart.updateTotals();
//     }, 2000);
//   }
// });
// var isUpdated = false;

// const bundlerButtonTimer = setInterval(function(){
//   if (document.querySelector('.bndlr-products-container .bndlr-add-to-cart') ) {
//     if (!isUpdated && document.querySelector('.bndlr-products-container .bndlr-add-to-cart .bndlr-checkmark')) {
//       isUpdated = true;
//       theme.partials.Cart.updateAllHtml(()=>{
//         if (theme.partials.OffCanvas.state === 'closed') {
//           theme.partials.OffCanvas.openRight();
//         }
//       });
//       theme.partials.Cart.updateTotals(()=>{});
//     } else if (!document.querySelector('.bndlr-products-container .bndlr-add-to-cart .bndlr-checkmark')) {
//       isUpdated = false;
//     }
//   }

//   if (document.querySelector('.bndlr-products-container .bndlr-add-bundle-to-cart') ) {
//     if (!isUpdated && document.querySelector('.bndlr-products-container .bndlr-add-bundle-to-cart .bndlr-checkmark')) {
//       isUpdated = true;
//       theme.partials.Cart.updateAllHtml(()=>{
//         if (theme.partials.OffCanvas.state === 'closed') {
//           theme.partials.OffCanvas.openRight();
//         }
//       });
//       theme.partials.Cart.updateTotals(()=>{});
//     } else if (!document.querySelector('.bndlr-products-container .bndlr-add-bundle-to-cart .bndlr-checkmark')) {
//       isUpdated = false;
//     }
//   }
// }, 500);


document.addEventListener('click', function(e){
  if ( typeof e.target.id !== undefined && (e.target.id == 'pn-modal-close-btn' || e.target.id == 'pn-mixed-cart-warning')) {
    document.getElementById('pn-mixed-cart-warning').classList.remove('pn-manual-modal-container');
    if (!document.body.classList.contains('template--cart')) {
      document.querySelector('.off-canvas--right-sidebar .cart--checkout-button button[name="checkout"]').click();
    }
  }
}); 

//window.addEventListener('theme:cart:updated', function(){
document.addEventListener('click', function(e) {
  if (e.target == document.querySelector('.off-canvas--right-sidebar .cart--checkout-button')) {
    let cartItems = document.querySelectorAll('.off-canvas--right-sidebar .cart--body .cart--item');
    let hasRegularItem = false;
    let hasPreOrderItem = false;
    cartItems.forEach(element => {
      if (element.innerHTML.includes('Pre-order')) {
        hasPreOrderItem = true;
      }
      if (!element.innerHTML.includes('Pre-order')) {
        hasRegularItem = true;
      }
    });
    if (hasPreOrderItem && hasRegularItem) {
      if (document.getElementById('pn-mixed-cart-warning')) {
        document.getElementById('pn-mixed-cart-warning').innerHTML = `<div id="pn-mixed-cart-warning-content" class="pn-manual-modal-content">
          <span id="pn-modal-close-btn">x</span>
          <h2 id="pn-mixed-cart-warning-title">Heads up: you have pre-order and in-stock items in the same cart!</h2>
          <div id="pn-mixed-cart-warning-text">You have a pre-order item in your cart. Your in-stock items will ship within 1-4 business days, but your pre-order item will be shipped at a later date. Please review the product's description for shipment date. Discounts cannot be applied to pre-order items as sales are hosted by Destira on behalf of the gym. If you have other questions or need immediate assistance please contact us at support@destira.com. </div>
        </div>`;
      } else {
        document.body.insertAdjacentHTML('beforeend', `<div id="pn-mixed-cart-warning" class="pn-modal pn-manual-modal-container" style="display: none;">
          <div id="pn-mixed-cart-warning-content" class="pn-manual-modal-content">
            <span id="pn-modal-close-btn">x</span>
            <h2 id="pn-mixed-cart-warning-title">Heads up: you have pre-order and in-stock items in the same cart!</h2>
            <div id="pn-mixed-cart-warning-text">You have a pre-order item in your cart. Your in-stock items will ship within 1-4 business days, but your pre-order item will be shipped at a later date. Please review the product's description for shipment date. Discounts cannot be applied to pre-order items as sales are hosted by Destira on behalf of the gym. If you have other questions or need immediate assistance please contact us at support@destira.com. </div>
          </div>
        </div>`);
      }
      document.getElementById('pn-mixed-cart-warning').classList.add('pn-manual-modal-container');
    } else {
      document.querySelector('.off-canvas--right-sidebar .cart--checkout-button button[name="checkout"]').click();
    }
  }
});

window.addEventListener('theme:cart:updated', async function(e) {
  var cart_item = document.querySelector('.drawer--root .cart--body .cart--item');

  if (typeof cart_item !== 'undefined') {
    var product_id = cart_item.getAttribute('data-product-id');
    var block = document.querySelector('.drawer--root .related-products--root');
    var container = document.querySelector('.drawer--root .related-products--root .related-products--grid');
    var t = await fetch(`${theme.urls.product_recommendations}?section_id=complementary-products&limit=2&product_id=${product_id}&intent=complementary`);
    if (!t.ok) throw new Error(t.statusText);
    var e = await t.text(),
      o = theme.utils.parseHtml(e).querySelectorAll("[data-product-item]");
    if (o.length) {
      const s = new DocumentFragment;
      o.forEach(t => s.append(t)), container.innerHTML = "", container.appendChild(s), block.style.display = "block"
    } else block && (block.style.display = "none")
  }
});

// document.addEventListener( "click", async function(e) {
//   if (e.target == document.querySelector('.collection--body--pagination .view-more') || e.target.closest('.collection--body--pagination .view-more')) {
//     e.preventDefault();

//     const nextButton = document.querySelector('.collection--body--pagination .view-more');
//     var nextPage = nextButton.getAttribute('data-next');
//     if (nextPage == null) {
//       nextPage = 2;
//     } else if (nextPage == 'none') {
//       return false;
//     }

//     var url = location.href;
//     if (url.includes('?')) {
//       url = location.href + `&page=${nextPage}`;
//     } else {
//       url = location.href + `?page=${nextPage}`;
//     }
    
//     const response = await fetch(url);
//     const htmlString = await response.text();
//     const parser = new DOMParser();
//     const html = parser.parseFromString(htmlString, 'text/html');

//     if ( typeof html.body !== "undefined" && html.body.querySelectorAll('.collection--body--grid .product--root').length > 0) {
//       document.querySelector('.collection--body--grid').insertAdjacentHTML('beforeend', html.body.querySelector('.collection--body--grid').innerHTML);
//       nextButton.setAttribute('data-next', parseInt(nextPage)+1);
//     } else {
//       nextButton.setAttribute('data-next', 'none');
//       nextButton.style.display = 'none';
//     }
//     return false;
//   }  
// });


var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

document.addEventListener("scroll", async (event) => {
  const nextButton = document.querySelector('.collection--body--pagination .view-more');
  if (typeof nextButton === "undefined" || nextButton == null) {
    return false;
  }

  var nextPage = nextButton.getAttribute('data-next');
  var isLoading = nextButton.getAttribute('is-loading');
  if (isLoading == "false" && isInViewport(nextButton)) {
    nextButton.setAttribute('is-loading', 'true');
    
    if (nextPage == null) {
      nextPage = 2;
    } else if (nextPage == 'none') {
      return false;
    }

    var url = location.href;
    if (url.includes('?')) {
      url = location.href + `&page=${nextPage}`;
    } else {
      url = location.href + `?page=${nextPage}`;
    }
    
    const response = await fetch(url);
    const htmlString = await response.text();
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');

    if ( typeof html.body !== "undefined" && html.body.querySelectorAll('.collection--body--grid .product--root').length > 0) {
      document.querySelector('.collection--body--grid').insertAdjacentHTML('beforeend', html.body.querySelector('.collection--body--grid').innerHTML);
      nextButton.setAttribute('data-next', parseInt(nextPage)+1);
      nextButton.setAttribute('is-loading', 'false');
    } else {
      nextButton.setAttribute('data-next', 'none');
      //nextButton.style.display = 'none';
    }
  }
  return false;
});

var shipping_collapsible_block = document.querySelector('body.wholesale .product-page--info [data-block-type="collapsible-row"]:last-child');
if (typeof shipping_collapsible_block !== 'undefined' && shipping_collapsible_block != null) {
  shipping_collapsible_block.querySelector('.collapsible-row--content').innerHTML = `<p><strong>SHIPPING:</strong></p><p>Rates and delivery time will vary depending on delivery location, chosen shipment method, carrier capacity and possible other factors.</p><p>Free standard shipping over $99 for contiguous continental US!</p><p>International shipping to Canada, Mexico, Australia and New Zealand. Both pre-paid and post-paid taxes and duties options available at checkout.</p><p><em>*Destira is not responsible for lost or stolen packages, or courier delays due to natural disasters or current events once the package leaves the Destira distribution center.</em></p><p><strong>RETURNS:</strong></p><p>Wholesale orders are not eligible for return. For assistance, please contact <a href="mailto:proshop@destira.com">proshop@destira.com</a></p>`
}

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}
window.addEventListener('resize', appHeight);
appHeight();
document.addEventListener("click", async (event) => {
  if (event.target == document.querySelector('.product-buy-buttons--smart--overlay')) {
    document.querySelector('.alert-message').classList.add("open");
  }
});

jQuery(document).ready(function(){
  checkIwishCount(2000);     
  jQuery("body").on("click",".iWishAdd, .iWishAddColl, .iwish-backdrop,.iwish_drawer_close",function(){
       checkIwishCount(500);
  });      
  function checkIwishCount(timer){          
      setTimeout(function(){
        var iwC1 = Number($('.iwish-counter').text());
        //console.log("iwC1: ",iwC1);            
        if(iwC1 > 0) {              
           $('.iwCountShow').show();
        }                                                         
        else {              
           $('.iwCountShow').hide();
        }                                   
      },timer);                                   
  }             
})